const firebaseConfig = {
  apiKey: "AIzaSyDFBehmS-_4f0s9bdpl-NeICWnB9VFhzFo",
  authDomain: "tbvdot-abfce.firebaseapp.com",
  projectId: "tbvdot-abfce",
  storageBucket: "tbvdot-abfce.appspot.com",
  messagingSenderId: "291086868534",
  appId: "1:291086868534:web:58b06e9ff981d1388cf897",
  measurementId: "G-4BJ1QDWJN3"
};
export default firebaseConfig;